import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from 'src/core/http/api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MyProfileService {
  private endPointBaseurl: string;

  constructor(private apiService: ApiService)  {
    this.endPointBaseurl = environment.appApiUrl;
  }


  public geMyProfile(): Observable<any> {
    return this.apiService.Get('myProfile');
  }


  public saveMyProfile(user: any): Observable<any> {
    return this.apiService.Post('myProfile', user);
  }


  public saveMyPassword(passwordObj: any): Observable<any> {
    return this.apiService.Post('myProfile/password', passwordObj);
  }


  public uploadAvatarImage(formData: FormData): Observable<any> {
    return this.apiService.Upload('myProfile/avatar', formData);
  }


}
